import React, { useState, useEffect } from "react";
import { registerUser } from "../../../../api/api.js";
import { useNavigate } from "react-router-dom";
import FinansistContragentSelect from "./FinansistContragentSelect";
import {
  buildFinansistContragentMappingPayload,
  emptyFinansistContragentFormState,
  formatMatchedFio,
} from "../../../../utils/finansistContragentMapping";
import "./Register.css";

function RegisterUser() {
  const navigate = useNavigate();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    patronymic: "",
    username: "",
    password: "",
    confirmPassword: "",
  });
  const [inputErrors, setInputErrors] = useState([]);
  const [finansistContragent, setFinansistContragent] = useState(
    emptyFinansistContragentFormState,
  );

  // Раньше загружались отделы/роли. Теперь это не требуется.

  useEffect(() => {
    if (formData.password !== formData.confirmPassword) {
      setInputErrors((prevErrors) => {
        const newErrors = [...prevErrors];
        if (!newErrors.includes("Пароли не совпадают")) {
          newErrors.push("Пароли не совпадают");
        }
        return newErrors;
      });
    } else {
      setInputErrors((prevErrors) =>
        prevErrors.filter((error) => error !== "Пароли не совпадают"),
      );
    }
  }, [formData.password, formData.confirmPassword]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      return;
    }

    // Новый контракт API: отправляем только необходимые поля
    const userData = {
      username: formData.username,
      hashed_password: formData.password,
      name: formData.name,
      surname: formData.surname,
      patronymic: formData.patronymic,
    };

    const finansistMapping = buildFinansistContragentMappingPayload({
      finansistContragent: finansistContragent.finansistContragent,
      matchedFio: formatMatchedFio(formData),
    });
    if (finansistMapping) {
      userData.finansist_contragent_mapping = finansistMapping;
    }

    console.log("Отправляемые данные:", userData);

    try {
      await registerUser(userData);
      setShowSuccessPopup(true);
      setFormData({
        name: "",
        surname: "",
        patronymic: "",
        username: "",
        password: "",
        confirmPassword: "",
      });
      setFinansistContragent(emptyFinansistContragentFormState());
      setTimeout(() => {
        setShowSuccessPopup(false);
        navigate("/account/admin/users");
      }, 3000);
    } catch (error) {
      alert(`Ошибка при регистрации: ${error.message}`);
    }
  };

  const handleKeyPress = (e, fieldName) => {
    if (fieldName === "E-mail") {
      // Разрешаем все символы для email
      return;
    }

    const char = String.fromCharCode(e.which);
    const pattern = /^[A-Za-z0-9@._-]+$/;
    if (!pattern.test(char)) {
      e.preventDefault();
      setInputErrors((prevErrors) => {
        const newErrors = [...prevErrors];
        if (
          !newErrors.includes(
            `Поле ${fieldName} должно содержать только латиницу, цифры и символы @._-`,
          )
        ) {
          newErrors.push(
            `Поле ${fieldName} должно содержать только латиницу, цифры и символы @._-`,
          );
        }
        return newErrors;
      });
    } else {
      setInputErrors((prevErrors) =>
        prevErrors.filter((error) => !error.includes(`Поле ${fieldName}`)),
      );
    }
  };

  const isFormValid = () => {
    const requiredFields = [
      "name",
      "surname",
      "username",
      "password",
      "confirmPassword",
    ];
    return (
      requiredFields.every((field) => formData[field].trim() !== "") &&
      inputErrors.length === 0
    );
  };

  return (
    <div className="registration">
      <form className="registration__form" onSubmit={handleSubmit}>
        <ul className="registration__inputs">
          <li className="registration__inputs-container">
            <label className="registration__label">Имя*</label>
            <input
              className="registration__input"
              placeholder="Введите имя"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </li>
          <li className="registration__inputs-container">
            <label className="registration__label">Фамилия*</label>
            <input
              className="registration__input"
              placeholder="Введите фамилию"
              type="text"
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              required
            />
          </li>
          <li className="registration__inputs-container">
            <label className="registration__label">Отчество</label>
            <input
              className="registration__input"
              placeholder="Введите отчество"
              type="text"
              name="patronymic"
              value={formData.patronymic}
              onChange={handleChange}
            />
          </li>
          <li className="registration__inputs-container">
            <label className="registration__label">Логин*</label>
            <input
              className="registration__input"
              placeholder="Введите логин"
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              onKeyPress={(e) => handleKeyPress(e, "Логин")}
              required
            />
          </li>
          <li className="registration__inputs-container">
            <label className="registration__label">Пароль*</label>
            <input
              className="registration__input"
              placeholder="Введите пароль"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              onKeyPress={(e) => handleKeyPress(e, "Пароль")}
              required
            />
          </li>
          <li className="registration__inputs-container">
            <label className="registration__label">Повторите пароль*</label>
            <input
              className="registration__input"
              placeholder="Повторите пароль"
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
          </li>
          <FinansistContragentSelect
            value={finansistContragent}
            onChange={setFinansistContragent}
          />
        </ul>
        {inputErrors.length > 0 && (
          <div className="error-messages">
            {inputErrors.map((error, index) => (
              <p key={index} className="error-message">
                {error}
              </p>
            ))}
          </div>
        )}
        <button
          className={`registration__button-submit ${
            !isFormValid() ? "button-disabled" : ""
          }`}
          type="submit"
          disabled={!isFormValid()}
        >
          Зарегистрировать
        </button>
      </form>
      {showSuccessPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <div className="popup-icon"></div>
            <p className="popup-text">Регистрация прошла успешно!</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default RegisterUser;
